// extracted by mini-css-extract-plugin
module.exports = {"botao":"BotaoTabela_botao__TWDTy","ativo":"BotaoTabela_ativo__31HrU","tooltip":"BotaoTabela_tooltip__2s6-G","img":"BotaoTabela_img__3vIGj"};